import JsonObject from "./JsonObject.js";
import NumberFormats from "./Number.js";
import StringFormats from "./String.js";

export default [...StringFormats, ...NumberFormats, ...JsonObject];
